import { contactoCreateSchema } from "@uirtus/shared";
import { useState, type FormEvent } from "react";
import type { Contacto } from "../lib/clientes";
import { Aviso, Boton, Campo, Entrada } from "./ui";

interface Props {
  contacto?: Contacto;
  enviando?: boolean;
  errorServidor?: string | null;
  alEnviar: (datos: Record<string, unknown>) => void;
  alCancelar: () => void;
}

export function FormularioContacto({
  contacto,
  enviando,
  errorServidor,
  alEnviar,
  alCancelar,
}: Props) {
  const [nombre, setNombre] = useState(contacto?.nombre ?? "");
  const [puesto, setPuesto] = useState(contacto?.puesto ?? "");
  const [email, setEmail] = useState(contacto?.email ?? "");
  const [telefono, setTelefono] = useState(contacto?.telefono ?? "");
  const [esPrincipal, setEsPrincipal] = useState(contacto?.esPrincipal ?? false);
  const [errores, setErrores] = useState<Record<string, string>>({});

  const limpiar = (v: string) => (v.trim() ? v.trim() : undefined);

  function enviar(e: FormEvent) {
    e.preventDefault();

    const datos = {
      nombre: nombre.trim(),
      puesto: limpiar(puesto),
      email: limpiar(email),
      telefono: limpiar(telefono),
      esPrincipal,
    };

    const resultado = contactoCreateSchema.safeParse(datos);
    if (!resultado.success) {
      const porCampo: Record<string, string> = {};
      for (const issue of resultado.error.issues) {
        const campo = String(issue.path[0] ?? "");
        if (campo && !porCampo[campo]) porCampo[campo] = issue.message;
      }
      setErrores(porCampo);
      return;
    }

    alEnviar(datos);
  }

  return (
    <form onSubmit={enviar} className="space-y-4 p-5">
      {errorServidor && <Aviso>{errorServidor}</Aviso>}

      <Campo etiqueta="Nombre" requerido error={errores["nombre"]}>
        <Entrada
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          error={!!errores["nombre"]}
        />
      </Campo>

      <Campo etiqueta="Puesto" error={errores["puesto"]}>
        <Entrada value={puesto} onChange={(e) => setPuesto(e.target.value)} />
      </Campo>

      <div className="grid gap-4 sm:grid-cols-2">
        <Campo etiqueta="Correo" error={errores["email"]}>
          <Entrada
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errores["email"]}
          />
        </Campo>
        <Campo etiqueta="Teléfono" error={errores["telefono"]}>
          <Entrada value={telefono} onChange={(e) => setTelefono(e.target.value)} />
        </Campo>
      </div>

      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={esPrincipal}
          onChange={(e) => setEsPrincipal(e.target.checked)}
          className="rounded border-slate-300 text-marca-600 focus:ring-marca-500"
        />
        {/* Solo puede haber uno: el backend desmarca al anterior. */}
        <span>Contacto principal</span>
      </label>

      <div className="flex justify-end gap-2 border-t border-slate-200 pt-4 dark:border-slate-800">
        <Boton type="button" variante="secundario" onClick={alCancelar}>
          Cancelar
        </Boton>
        <Boton type="submit" disabled={enviando}>
          {enviando ? "Guardando…" : contacto ? "Guardar" : "Agregar"}
        </Boton>
      </div>
    </form>
  );
}
